import React from 'react'

import OverviewComponent from '../../components/developerApi/developerSdk/Overview/OverviewComponent'

import './overviewLayout.scss'

class OverviewLayout extends React.Component {
    render() {
        return <div className="overview-layout">
            <h2>Introduction</h2>
            <OverviewComponent />
        </div>
    }
}

export default OverviewLayout



// WEBPACK FOOTER //
// ./src/layouts/Overview/OverviewLayout.js